// src/Components/BlogDetail.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";

export default function BlogDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchBlog() {
      try {
        const ref = doc(db, "blogs", id);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          setBlog({ id: snap.id, ...snap.data() });
        } else {
          console.error("Blog not found");
        }
      } catch (err) {
        console.error("Error loading blog:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchBlog();
  }, [id]);

  if (loading) {
    return (
      <div style={{ padding: 16, maxWidth: 900, margin: "0 auto" }}>
        <p>Loading blog...</p>
      </div>
    );
  }

  if (!blog) {
    return (
      <div style={{ padding: 16, maxWidth: 900, margin: "0 auto" }}>
        <p>Blog not found.</p>
        <button
          onClick={() => navigate("/blogs")}
          style={{
            marginTop: 8,
            padding: "6px 12px",
            borderRadius: 4,
            border: "none",
            backgroundColor: "#007bff",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          Back to Blogs
        </button>
      </div>
    );
  }

  const { title, author, date, category, imageUrl, content, excerpt } = blog;

  // Content is plain text. Support line breaks.
  const paragraphs = (content || "").split("\n").filter((p) => p.trim().length);

  return (
    <div
      className="blog-detail-container"
      style={{
        padding: 16,
        maxWidth: 900,
        margin: "0 auto",
        backgroundColor: "#fff",
        borderRadius: 8,
        boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
      }}
    >
      {/* Back button */}
      <button
        onClick={() => navigate("/blogs")}
        style={{
          marginBottom: 12,
          padding: "6px 12px",
          borderRadius: 4,
          border: "none",
          backgroundColor: "#e0e0e0",
          color: "#333",
          cursor: "pointer",
          fontSize: 14,
        }}
      >
        ← Back to Blogs
      </button>

      {/* Image banner */}
      {imageUrl && (
        <div
          style={{
            width: "100%",
            maxHeight: 320,
            overflow: "hidden",
            borderRadius: 8,
            marginBottom: 16,
          }}
        >
          <img
            src={imageUrl}
            alt={title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
      )}

      {/* Title + meta */}
      <h1 style={{ margin: "0 0 8px 0", fontSize: 26 }}>{title}</h1>

      <p style={{ margin: "0 0 12px 0", fontSize: 13, color: "#666" }}>
        {author || "Unknown"} • {date || ""} •{" "}
        <span style={{ fontWeight: 600 }}>{category}</span>
      </p>

      {/* Optional short excerpt under title */}
      {excerpt && (
        <p
          style={{
            margin: "0 0 16px 0",
            fontSize: 15,
            color: "#444",
            fontStyle: "italic",
          }}
        >
          {excerpt}
        </p>
      )}

      <hr style={{ border: "none", borderTop: "1px solid #eee", margin: "12px 0 16px" }} />

      {/* Full content */}
      <div
        className="blog-content"
        style={{ fontSize: 15, color: "#333", lineHeight: 1.6 }}
      >
        {paragraphs.length ? (
          paragraphs.map((p, idx) => (
            <p key={idx} style={{ marginBottom: 12 }}>
              {p}
            </p>
          ))
        ) : (
          <p>No content available.</p>
        )}
      </div>
    </div>
  );
}
